import { ButtonLink } from "@/shared/components/ButtonLink";

type PageHeaderProps = {
  children: React.ReactNode;
  className?: string;
};

export function PageHeader({ children, className }: PageHeaderProps) {
  return (
    <header className={`page-header${className ? ` ${className}` : ""}`}>
      {children}
    </header>
  );
}

type PageActionsProps = {
  children?: React.ReactNode;
};

export function PageActions({ children }: PageActionsProps) {
  return <div className="page-actions">{children}</div>;
}

type PageTitleProps = {
  children: React.ReactNode;
};

export function PageTitle({ children }: PageTitleProps) {
  return (
    <h1 className="page-title text-2xl font-semibold text-[color:var(--text-primary)]">
      {children}
    </h1>
  );
}

type PageActionButtonProps = {
  href?: string;
  to?: string;
  label: string;
};

export function PageActionButton({ href, to, label }: PageActionButtonProps) {
  return (
    <ButtonLink
      to={to ?? href ?? ""}
      variant="primary"
      size="lg"
      shape="pill"
    >
      {label}
    </ButtonLink>
  );
}
